export default {
  biIncidentReportsByType: 'BI_INCIDENT_REPORTS_BY_TYPE',
  biIncidentReportsGroupedByDateAndType: 'BI_INCIDENT_REPORTS_GROUPED_BY_DATE_AND_TYPE',
  biIncidentReportsGroupedByDate: 'BI_INCIDENT_REPORTS_GROUPED_BY_DATE',
  setLoadingState: 'BI_INCIDENT_REPORTS_SET_LOADING_STATE',
};